import { useState } from "react";
import { supabase } from "../supabaseClient";
import { Upload, Loader2, Image as ImageIcon } from "lucide-react";

export default function ImageUpload({ 
  bucket, 
  onUploadComplete, 
  currentImage, 
  height = "h-32", 
  width = "w-32",
  shape = "rounded-full" 
}) {
  const [uploading, setUploading] = useState(false);

  const uploadImage = async (event) => {
    try {
      setUploading(true);

      if (!event.target.files || event.target.files.length === 0) {
        throw new Error("You must select an image to upload.");
      }

      const file = event.target.files[0];
      const fileExt = file.name.split(".").pop();
      // Create a unique file name: timestamp-random.ext
      const fileName = `${Date.now()}-${Math.random().toString(36).substring(2)}.${fileExt}`;
      const filePath = `${fileName}`;

      // 1. Upload to Supabase Storage
      const { error: uploadError } = await supabase.storage
        .from(bucket)
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      // 2. Get the Public URL
      const { data } = supabase.storage.from(bucket).getPublicUrl(filePath);
      
      // 3. Pass DATA back to parent (UPDATED STEP)
      // We pass an object so the parent can save the short path to DB 
      // but use the long URL to display the image immediately.
      onUploadComplete({
        path: filePath,       // e.g. "1715622.png"
        fullUrl: data.publicUrl // e.g. "https://supabase.../1715622.png"
      });

    } catch (error) {
      alert(error.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-4">
      <div className={`relative ${height} ${width} ${shape} overflow-hidden border-2 border-dashed border-gray-300 bg-gray-50 flex items-center justify-center group`}>
        
        {/* Display Image */}
        {currentImage ? (
          <img
            src={currentImage}
            alt="Upload"
            className="w-full h-full object-cover"
          />
        ) : (
          <ImageIcon className="text-gray-400" size={32} />
        )}

        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer">
           <Upload className="text-white" size={24} />
        </div>

        {/* Loading Spinner */}
        {uploading && (
          <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-10">
            <Loader2 className="animate-spin text-blue-600" size={32} />
          </div>
        )}

        {/* Hidden Input */}
        <input
          type="file"
          accept="image/*"
          onChange={uploadImage}
          disabled={uploading}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        />
      </div>
      <span className="text-xs text-gray-500">Click to upload</span>
    </div>
  );
}